export default __webpack_public_path__ + "static/media/cancel.856c5926.svg";